export default __webpack_public_path__ + "static/media/checked.4405b613.svg";